import React from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import MainSection from "../../components/mainLayout/Main";
import ViewTaskHome from "./components/ViewTaskHome";

const ViewTask = () => {
  return (
    <>
      <Sidebar />

      <MainSection>
        {/* <SectionHeader title="Task Details" /> */}
        <ViewTaskHome />
      </MainSection>
    </>
  );
};

export default ViewTask;
